import { MapLike, StateSnapshot } from '@iotv/iotv-v3-types'
import { randn_bm } from '../math'

export type KeyRange = {
  min: number
  max: number
  skew: number
}

export type KeyRangeMap = {
  [key: string]: KeyRange
}

export const getStateSample = (keyRangeMap: KeyRangeMap): MapLike<number | null> => {
  const res: MapLike<number | null> = Object.fromEntries(Object.entries(keyRangeMap).map(([k, v]) => [k, randn_bm(v.min, v.max, v.skew)]))
  return res
}

export const getStateSnapshotSample = (timestamp: number, keyRangeMap: KeyRangeMap): StateSnapshot<any> => ({ timestamp, state: getStateSample(keyRangeMap) })
